import EditArtist from "../../../pages/artist/Edit";
import {getArtistRoute} from "./factory/artist";

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
    {
        path: getArtistRoute(),
        component: EditArtist,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;